import React from "react";
import { Link } from "react-router-dom";
import { RoutePaths } from "../../common/RoutePaths";

const GameCard = ({ image, alt, gameName }) => {
  return (
    <Link  to={RoutePaths.GAME_LOBBY.replace(":gameId", gameName || 'blackjack')} className="block relative w-full aspect-square shadow-sm overflow-hidden transition-all duration-300 cursor-pointer group">
      {image && (
        <img
          src={image}
          alt={alt || "Game"}
          className="h-full w-full object-fill transition-transform duration-700 ease-out"
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
    </Link>
  );
};

export default GameCard;

